<template>
  <v-card class="pa-2">
    <v-card-title>موعد های پرداختی</v-card-title>
    <v-data-table
      v-model="selected"
      :headers="admin ? headers2 : headers"
      :items="
        admin
          ? info.data
          : info.filter((item) => item.type === 'charge' && !item.is_paid)
      "
      show-select
      item-key="id"
      class="elevation-1"
      :loading="loadingPage"
    >
      <!-- اسلات برای ستون شماره ردیف -->
      <template v-slot:item.index="{ index }">
        {{ index + 1 }}
      </template>
      <!-- اسلات برای ستون نام -->
      <template v-slot:item.qr="{ item }">
        <span>{{ item.qr }} </span>
      </template>

      <template v-slot:item.price="{ item }">
        <span>{{ item.price.toLocaleString() }}</span>
      </template>

      <template v-slot:item.time="{ item }">
        <!-- <span>{{ item.due_date }}</span> -->
        <span>{{ getPersianDate(item.due_date) }}</span>
      </template>

      <template v-slot:item.fine="{ item }">
        <span style="color: red">{{ item.fine ?? "-" }} </span>
      </template>

      <template v-slot:item.description="item">
        <span> شارژ</span>
      </template>
      <!-- اسلات برای ستون عملیات -->
      <template v-if="!admin" v-slot:item.action="{ item }">
        <v-btn
          small
          color="primary"
          outlined
          @click="
            gate = true;
            gateSetting.inf = item;
          "
          >پرداخت
          <v-icon class="mr-2">mdi-cash</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <custom-popup maxWidth="600px" v-model="gate" :cons="{ title: 'پرداخت' }">
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row
              class="w-100 pa-2 d-flex flex-column align-items-center justify-content-center"
            >
              <v-col cols="12">
                <v-card
                  @click="switchGateType('gate')"
                  :elevation="gateType === 'gate' ? 3 : 0"
                  class="w-100 d-flex align-items-center justify-content-around"
                  :class="gateType === 'gate' ? '' : 'border'"
                  rounded="xl"
                  style="cursor: pointer"
                >
                  <v-avatar>
                    <v-icon>mdi-account-credit-card-outline</v-icon>
                  </v-avatar>

                  <v-card-title>پرداخت از طریق درگاه های عضو شتاب</v-card-title>
                  <v-card-action v-if="gateType === 'gate'">
                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                  </v-card-action>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card
                  :elevation="gateType === 'card' ? 3 : 0"
                  class="w-100 d-flex align-items-center justify-content-around border align-items-center"
                  rounded="xl"
                  style="cursor: pointer"
                  @click="switchGateType('card')"
                >
                  <v-avatar>
                    <v-icon>mdi-credit-card-multiple</v-icon>
                  </v-avatar>

                  <v-card-title> کارت به کارت </v-card-title>
                  <v-card-action v-if="gateType === 'card'">
                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                  </v-card-action>
                </v-card>
              </v-col>
              <v-col cols="12" class="d-flex justify-content-end">
                <v-btn
                  @click="e1 = 2"
                  :disabled="gateType.length == 0"
                  outlined
                  color="green"
                >
                  ادامه
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="pa-2">
              <select-gate-slaes v-model="gateSetting.gate" />
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <v-btn outlined color="red" @click="e1 = 1">
                  <v-icon>mdi-chevron-right</v-icon>
                  بازگشت
                </v-btn>
                <v-btn
                  :disabled="Object.keys(gateSetting.gate).length == 0"
                  outlined
                  color="green"
                  @click="e1 = 3"
                >
                  ادامه
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div class="pa-2">
              <v-card elevation="2" rounded="xl">
                <v-card-title>
                  مبلغ قابل پرداخت :
                  {{ gateSetting?.inf?.price?.toLocaleString() }} ﷼
                </v-card-title>
              </v-card>
              <v-col cols="12" class="d-flex justify-content-between">
                <v-btn outlined @click="e1 = 2" color="red">
                  <v-icon>mdi-chevron-right</v-icon>
                  بازگشت
                </v-btn>
                <v-btn outlined color="green">
                  پرداخت
                  <v-icon>mdi-credit-card-multiple</v-icon>
                </v-btn>
              </v-col>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </custom-popup>
  </v-card>
</template>

<script>
import selectGateSlaes from "../components/gate/selectGateSlaes.vue";
export default {
  components: { selectGateSlaes },
  props: {
    loadingPage: Boolean,
    info: Array,
    admin: Boolean,
  },
  data() {
    return {
      selected: [], // برای ذخیره ردیف‌های انتخاب‌شده
      headers: [
        { value: "index", text: "ردیف", sortable: false }, // ستون جدید برای شماره ردیف
        { value: "price", text: "مبلغ پرداخت (تومان)", sortable: true },
        { value: "time", text: "موعد پرداخت", sortable: false },
        { value: "fine", text: "جریمه(درصد)", sortable: false },
        { value: "description", text: "توضیحات", sortable: false },
        { value: "action", text: "عملیات", sortable: false },
      ],
      headers2: [
        { value: "index", text: "ردیف", sortable: false }, // ستون جدید برای شماره ردیف
        { value: "price", text: "مبلغ پرداخت (تومان)", sortable: true },
        { value: "time", text: "موعد پرداخت", sortable: false },
        { value: "fine", text: "جریمه(درصد)", sortable: false },
        { value: "description", text: "توضیحات", sortable: false },
      ],
      gate: false,
      e1: 1,

      gateType: "", // مقدار اولیه
      gateSetting: {
        type: "",
        gate: {},
        inf: {},
      },
      // داده‌های نمونه
    };
  },
  watch: {
    gateType(val) {
      const newItem = {
        type: val,
        gate: {},
        inf: this.gateSetting.inf,
      };
      this.gateSetting = newItem;
    },
    gate(val) {
      if (!val) {
        this.gateType = "";
        this.e1 = 1;
        this.gateSetting = {
          type: "",
          gate: {},
          inf: {},
        };
      }
    },
  },

  methods: {
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "تاریخ نامعتبر";
      const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return formatter.format(date);
    },
    switchGateType(type) {
      this.gateType = this.gateType === type ? "" : type;
    },
  },
};
</script>

<style scoped>
/* استایل‌های اضافی برای جدول */
.elevation-1 {
  margin: 20px;
  text-align: center;
}
</style>
